import React, { ReactElement } from 'react';
import { GroupBase, SelectComponentsConfig } from 'react-select';

import ClearIndicator from './ClearIndicator';
import DropdownIndicator from './DropdownIndicator';
import MenuList from './MenuList';
import MultiValueContainer from './MultiValueContainer';
import Option from './Option';

export function selectComponents<
  T,
  IsMulti extends boolean,
  Group extends GroupBase<T>
>(): SelectComponentsConfig<T, IsMulti, Group> {
  return {
    DropdownIndicator,
    Option,
    MenuList,
    ClearIndicator,
    MultiValueContainer,
    IndicatorSeparator: (): ReactElement => <></>,
  };
}
